module.exports = __webpack_public_path__ + "img/webpiecesplitscreen.jpg.2ccee422.webp";